import { isDefined } from './validation.helper';
import { isNumber } from './type.helper';

const decimalsFormatter = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 2
});

export const currencyFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR'
});

const decimalsFormatter2Digits = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
});

const decimalsFormatter2DigitsWithoutGrouping = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  useGrouping: false
});

const decimalsFormatter0DigitsWithoutGrouping = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  useGrouping: false
});

const numberFormatter = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  useGrouping: true
});

export function formatCurrency(value = 0): string {
  return currencyFormatter.format(value);
}

export function formatDecimal(value = 0): string {
  return decimalsFormatter.format(value);
}

export function formatDecimal2Digits(value = 0): string {
  return decimalsFormatter2Digits.format(value);
}

export function formatDecimal2DigitsWithoutGrouping(value = 0): string {
  return decimalsFormatter2DigitsWithoutGrouping.format(value);
}

export function formatDecimal0DigitsWithoutGrouping(value = 0): string {
  return decimalsFormatter0DigitsWithoutGrouping.format(value);
}

export function formatDecimal0Digits(value = 0) {
  return numberFormatter.format(value);
}

export function round(value: number, decimals = 2) {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}

export function numberStringToNumber(value: string): number {
  return value === '' ? null : +value.replaceAll(',', '.');
}

/**
 * Liefert den ersten Wert solange dieser nicht größer wie der zweite Wert ist, sonst wird der zweite Wert zurückgegeben
 */
export function valueNotGreater(first: number, second: number): number {
  return Math.min(first, second);
}

export function ensureNumberValue(value: number | undefined): number {
  if (isNumber(value)) {
    return value;
  } else {
    return 0;
  }
}

export function isIntString(value?: string): boolean {
  return new RegExp(/^\d+$/).test(value);
}

export class DecimalNumberHelper {
  static asDecimalNumberString(
    value: number,
    extension = '',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2
  ): string {
    if (isDefined(value)) {
      const formattedNumber = value.toLocaleString('de-DE', { minimumFractionDigits, maximumFractionDigits });
      return `${formattedNumber} ${extension}`;
    } else {
      const zero = 0;
      const formatedZero = zero.toLocaleString('de-DE', { minimumFractionDigits, maximumFractionDigits });
      return `${formatedZero} ${extension}`;
    }
  }
}
